<div class="min-h-screen flex flex-col bg-gradient-to-b from-[#fcfefc] to-[#f4fbf8]">
  <div class="flex-1">
    <div class="flex justify-center px-6 pt-8">
      <img
        src="assets/images/asg_care_logo_black.svg"
        alt="ASG Care"
        class="h-auto w-[min(220px,55vw)]"
      />
    </div>

    <div class="py-10 px-6">
      <lib-stepper
        [numberOfSteps]="numberOfSteps"
        [activeStepIndex]="activeStep"
        (resetEvent)="reset()"
        (previousStepEvent)="previousStep()"
      ></lib-stepper>

      <!-- Content -->
      <div class="select-none">
    <div
      *ngIf="activeStep == 0"
      class="p-4 h-full flex flex-col mt-12 items-center"
    >
      <div class="text-center mt-32">
        <div class="font-syne mb-10">
          <p class="text-3xl font-semibold leading-9">
            Få et forsikringstilbud – hurtigt og uforpligtende
          </p>
          <p class="leading-9 text-[#2D3748]">
            Indtast din nummerplade, så henter vi automatisk oplysninger om din
            bil og beregner din pris
          </p>
        </div>

        <div class="">
          <input
            [ngClass]="{ 'border-red-500': this.errorInRegOrVinNumber }"
            *ngIf="!loadingRegOrVinNumber"
            [(ngModel)]="regOrVinNumber"
            (ngModelChange)="receivedDMRVehicle = false"
            (keydown.enter)="dmrInfo()"
            type="text"
            class="my-10 uppercase font-inter py-3 px-4 block w-full border-0 border-b border-gray-200 placeholder-gray-300 text-center text-lg focus:border-gray-200 focus:ring-0"
            [placeholder]="
              regOrVinNumberInputFocused ? '' : 'NUMMERPLADE ELLER STELNUMMER'
            "
            (focus)="regOrVinNumberInputFocused = true"
            (blur)="regOrVinNumberInputFocused = false"
          />

          <div *ngIf="specialCarError" class="font-syne my-10">
            <p class="font-semibold">{{ vehicleFromDmr.make }}</p>
            <p class="text-gray-500 text-sm">
              Det indtastede køretøj anses for at være en specialbil.
            </p>
            <p class="text-gray-500 text-sm">
              Kontakt os på support&#64;asgcare.dk for en pris.
            </p>
          </div>

          <div
            *ngIf="
              (loadingRegOrVinNumber && !receivedDMRVehicle) || loadingDmrScrape
            "
            class="flex flex-col items-center justify-center"
          >
            <div>
              <lib-loading-indicator size="10"></lib-loading-indicator>
            </div>
            <div>
              <div
                class="text-base font-medium leading-[24px] tracking-tight text-center mt-2"
              >
                Finder bil...
              </div>
            </div>
          </div>

          <div
            *ngIf="
              !loadingRegOrVinNumber && receivedDMRVehicle && !loadingDmrScrape
            "
          >
            <p class="text-3xl font-syne">
              {{ vehicleFromDmr.make }}
              {{ vehicleFromDmr.model }}
            </p>

            <button
              (click)="dmrScrape()"
              type="button"
              class="py-1 px-4 inline-flex items-center gap-x-2 text-xs font-semibold rounded-lg border border-transparent text-teal-500 hover:text-teal-600 disabled:opacity-50 disabled:pointer-events-none"
            >
              Ikke korrekt? Tryk her
            </button>
          </div>

          <button
            *ngIf="!loadingRegOrVinNumber && !receivedDMRVehicle"
            (click)="dmrInfo()"
            (enter)="dmrInfo()"
            type="button"
            class="py-3 px-4 shadow-lg font-inter inline-flex items-center gap-x-1 text-sm rounded-full border border-transparent bg-teal-450 text-white hover:bg-teal-500 disabled:opacity-50 disabled:pointer-events-none"
          >
            Find bil
          </button>

          <p class="font-inter text-gray-400 text-sm mt-10">
            Har du ikke et reg.- eller stelnummer? <br />
            Kontakt os på +45 70 44 41 44 <br />
            eller på
            <a class="underline" href="mailto:support@asgcare.dk"
              >support&#64;asgcare.dk</a
            >
          </p>

          <div class="">
            <button
              *ngIf="
                !loadingRegOrVinNumber &&
                receivedDMRVehicle &&
                !loadingDmrScrape
              "
              (click)="nextStep()"
              type="button"
              class="py-3 px-4 focus:outline-none shadow-lg m-10 font-inter inline-flex items-center gap-x-1 text-sm rounded-full border border-transparent bg-teal-450 text-white hover:bg-teal-500 disabled:opacity-50 disabled:pointer-events-none"
            >
              Start
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- ######  Step 1 ###### -->
    <div *ngIf="activeStep == 1">
      <div class="max-w-[85rem] lg:px-8 py-10 mx-auto">
        <div class="flex items-center h-full">
          <div class="u-fade-in-step">
            <div class="mb-6">
              <div
                [ngClass]="{
                  'text-red-500': this.errorInPurchasedOrLeased,
                }"
                class="font-syne text-2xl font-semibold mb-5"
              >
                Er bilen købt eller leaset?
              </div>
              <div class="flex flex-col md:flex-row gap-4 my-5">
                <button
                  (click)="carOwnershipType = 'bought'"
                  [ngClass]="{
                    'bg-[#F1FCF9] border-[#1FAD96]':
                      carOwnershipType === 'bought',
                    'bg-white border-gray-100': carOwnershipType !== 'bought',
                  }"
                  class="h-32 w-full md:w-40 text-center rounded-lg border flex flex-col items-center justify-center space-y-2"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-user"
                  >
                    <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
                    <circle cx="12" cy="7" r="4" />
                  </svg>
                  <p class="font-inter text-sm py-2">Købt</p>
                  <input
                    id="bought"
                    name="notification-method"
                    type="radio"
                    [(ngModel)]="carOwnershipType"
                    value="bought"
                    class="h-4 w-4 border-gray-300 text-[#1FAD96] focus:ring-[#1FAD96]"
                  />
                </button>

                <button
                  (click)="carOwnershipType = 'operationalLease'"
                  [ngClass]="{
                    'bg-[#F1FCF9] border-[#1FAD96]':
                      carOwnershipType === 'operationalLease',
                    'bg-white border-gray-100':
                      carOwnershipType !== 'operationalLease',
                  }"
                  class="h-32 w-full md:w-40 text-center rounded-lg border flex flex-col items-center justify-center space-y-2"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-car"
                  >
                    <path
                      d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2"
                    />
                    <circle cx="7" cy="17" r="2" />
                    <path d="M9 17h6" />
                    <circle cx="17" cy="17" r="2" />
                  </svg>

                  <p class="font-inter text-sm py-2">Operationel leasing</p>
                  <input
                    id="operationalLease"
                    name="notification-method"
                    type="radio"
                    [(ngModel)]="carOwnershipType"
                    value="operationalLease"
                    class="h-4 w-4 border-gray-300 text-[#1FAD96] focus:ring-[#1FAD96]"
                  />
                </button>

                <button
                  (click)="carOwnershipType = 'financialLease'"
                  [ngClass]="{
                    'bg-[#F1FCF9] border-[#1FAD96]':
                      carOwnershipType === 'financialLease',
                    'bg-white border-gray-100':
                      carOwnershipType !== 'financialLease',
                  }"
                  class="h-32 w-full md:w-40 text-center rounded-lg border flex flex-col items-center justify-center space-y-2"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-car-front"
                  >
                    <path
                      d="m21 8-2 2-1.5-3.7A2 2 0 0 0 15.646 5H8.4a2 2 0 0 0-1.903 1.257L5 10 3 8"
                    />
                    <path d="M7 14h.01" />
                    <path d="M17 14h.01" />
                    <rect width="18" height="8" x="3" y="10" rx="2" />
                    <path d="M5 18v2" />
                    <path d="M19 18v2" />
                  </svg>

                  <p class="font-inter text-sm py-2">Finansiel leasing</p>
                  <input
                    id="financialLease"
                    name="notification-method"
                    type="radio"
                    [(ngModel)]="carOwnershipType"
                    value="financialLease"
                    class="h-4 w-4 border-gray-300 text-[#1FAD96] focus:ring-[#1FAD96]"
                  />
                </button>
              </div>

              <!-- If carOwnershipType is selected -->
              <div *ngIf="carOwnershipType !== ''" class="u-fade-in-step">
                <div class="font-syne text-2xl font-semibold mb-5">
                  Bilens handelspris
                  <span
                    *ngIf="carOwnershipType == 'leased'"
                    class="text-gray-500 text-sm"
                  >
                    u. moms og reg. afgift
                  </span>
                </div>

                <div class="w-56 mb-6">
                  <app-searchable-select
                    [title]="'Handelspris'"
                    [index]="'selectedPrice-dropdown'"
                    [errorInDropdown]="errorInCarPrice"
                    [selectedValue]="selectedPrice.name"
                    [options]="dropdown_carPrice"
                    [filterFunction]="priceFilterFunction"
                    (output)="dropdownOutput($event, 'price')"
                  ></app-searchable-select>
                </div>

                <!-- If selectedPrice is selected -->
                <div *ngIf="selectedPrice.value !== 0" class="u-fade-in-step">
                  <div class="font-syne text-2xl font-semibold mb-5">
                    Din alder
                  </div>

                  <div class="w-56 mb-6">
                    <app-input
                      class="component-container"
                      (keyup)="validateCustomerAge()"
                      [(ngModel)]="customerAge"
                      [errorInInput]="errorInCustomerAge"
                      [isValidInput]="isCustomerAgeValid"
                      [title]="'Alder'"
                      type="number"
                    ></app-input>
                  </div>

                  <!-- If customerAge is selected -->
                  <div
                    *ngIf="isCustomerAgeValid && !errorInCustomerAge"
                    class="u-fade-in-step"
                  >
                    <div class="font-syne text-2xl font-semibold mb-5">
                      Dit postnummer
                    </div>

                    <div class="w-56 mb-6">
                      <app-input
                        class="component-container"
                        (keyup)="validateZipCode()"
                        [(ngModel)]="zipCode"
                        [errorInInput]="errorInZipCode"
                        [isValidInput]="isZipcodeValid"
                        [title]="'Postnr.'"
                        type="number"
                      ></app-input>
                    </div>

                    <!-- If zipCode is selected -->
                    <div
                      *ngIf="isZipcodeValid && !errorInZipCode"
                      class="u-fade-in-step"
                    >
                      <button
                        *ngIf="!loadinginsuranceInfo"
                        (click)="validateBasicInfo()"
                        type="button"
                        class="py-3 px-4 shadow-lg font-inter inline-flex items-center gap-x-1 text-sm rounded-full border border-transparent bg-[#34C0A7] text-white hover:bg-teal-500 disabled:opacity-50 disabled:pointer-events-none"
                      >
                        Næste
                      </button>

                      <div class="m-5" *ngIf="loadinginsuranceInfo">
                        <lib-loading-indicator
                          size="10"
                        ></lib-loading-indicator>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ######  Step 2 ###### -->
  <div *ngIf="activeStep >= 2">
    <!-- ############################################################ -->
    <div class="max-w-[85rem] lg:px-8 py-10 mx-auto">
      <div
        *ngIf="activeStep == 2"
        class="flex items-center justify-center select-none"
      >
        <div
          class="mb-4 flex items-center justify-center bg-[#F1FCF9] rounded-l-full rounded-r-full"
        >
          <div
            [ngClass]="
              showYearlyPrice
                ? 'bg-[#072C29] text-[#F1FCF9] rounded-r-full'
                : 'bg-[#F1FCF9] text-[#072C29]'
            "
            (click)="showYearlyPrice = !showYearlyPrice"
            class="font-inter w-32 text-center text-xs p-1 rounded-l-full cursor-pointer"
          >
            Årlig
          </div>
          <div
            [ngClass]="
              !showYearlyPrice
                ? 'bg-[#072C29] text-[#F1FCF9] rounded-l-full'
                : 'bg-[#F1FCF9] text-[#072C29]'
            "
            (click)="showYearlyPrice = !showYearlyPrice"
            class="font-inter w-32 text-center text-xs p-1 rounded-r-full cursor-pointer"
          >
            Månedlig
          </div>
        </div>
      </div>
      <!-- ############# -->

      <ng-container>
        <app-price-calculator
          *ngIf="activeStep >= 2"
          [activeStep]="activeStep"
          [showHelvetiaInfo]="showHelvetiaInfo"
          [showKSFInfo]="showKsfInfo"
          [helvetiaVariants]="helvetiaVariants"
          [helvetiaMonthlyPrice]="helvetiaMonthlyPrice"
          [helvetiaYearlyPrice]="helvetiaYearlyPrice"
          [ksfMonthlyPrice]="ksfMonthlyPrice"
          [ksfPrice]="ksfPrice"
          [ksfTemplate]="ksfTemplate"
          [ksfExcessTab]="ksfExcessTab"
          [ksfPriceResult]="ksfPriceResult"
          [ksfPriceLoading]="loadinginsuranceInfo"
          [allHaveToggleChargingStandAllowed]="true"
          [allHaveTogglePricetag]="false"
          [showYearlyPrice]="showYearlyPrice"
          [errorIngetInsurancePrices]="errorIngetInsurancePrices"
          [errorInKsfPrice]="errorInKsfPrice"
          [errorInHelvetiaPrice]="errorInHelvetiaPrice"
          [customerAge]="customerAge"
          [zipCode]="zipCode"
          [carOwnershipType]="carOwnershipType"
          [vehicleFromDmr]="vehicleFromDmr"
          [selectedHelvetiaVariant]="selectedHelvetiaVariant"
          [selectedPrice]="selectedPrice"
          (pickHelvetiaEvent)="pickHelvetiaPrice($event)"
          (pickKsfEvent)="pickKsf($event)"
          (nextStepEvent)="nextStep()"
          (resetEvent)="reset()"
          (togglePriceIntervalEvent)="showYearlyPrice = !showYearlyPrice"
          (setYearlyMonthlyPriceEvent)="helvetiaMonthlyPrice = $event"
          (setYearlyPriceEvent)="helvetiaYearlyPrice = $event"
          (setSelectedHelvetiaVariantEvent)="selectedHelvetiaVariant = $event"
          (helvetiaVariantsChange)="helvetiaVariants = $event"
          (setKsfTemplateEvent)="ksfTemplate = $event"
          (setHelvetiaCustomerInfoEvent)="helvetiaCustomerInfo = $event"
          (setKsfCustomerInfoEvent)="ksfCustomerInfo = $event"
        ></app-price-calculator>
      </ng-container>
    </div>
      </div>
    </div>
  </div>

  <footer class="px-6 pb-6">
    <div class="mx-auto mb-4 h-px w-full max-w-[1100px] bg-[#1fad96]/45"></div>
    <div class="text-center text-sm leading-[1.4] text-[#072c29]">
      <p class="m-0">ASG CARE A/S</p>
      <p class="m-0">Bondovej 16</p>
      <p class="m-0">5250 Odense SV</p>
      <p class="m-0">CVR 42304581</p>
    </div>
    <a
      href="mailto:support@asgcare.dk"
      class="mx-auto mt-4 flex w-fit min-w-[116px] items-center justify-center rounded-full border-2 border-[#0d9ea1] bg-white px-6 py-[0.7rem] text-base leading-none text-[#072c29] no-underline transition-colors duration-200 hover:bg-[#f1fcf9]"
    >
      Kontakt os
    </a>
  </footer>
</div>
